import { errorLogger } from '@ajaibid/utils';
import fetcher from '@helpers/fetcher';
import { serializeQueryString } from 'Util/fetcher';

function getUrl(code) {
  const query = serializeQueryString({ ticker_code: code });
  return `v1/stock/mt/tradelimit/${query}`;
}

/**
 * @param {string} url
 */
function callbackFetch(url) {
  return async () => {
    try {
      /** @type {import('./typedefs').Response} */
      const res = await fetcher.get(url);

      return res.data?.result;
    } catch (err) {
      errorLogger('ERROR_API', err.message);
      throw err;
    }
  };
}

/**
 * @param {string} stockCode
 */
export default function fetch(stockCode) {
  const url = getUrl(stockCode);

  return {
    cb: callbackFetch(url),
    key: [url],
  };
}
